import { Interval } from 'luxon';
import React from 'react';
import { Redirect, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

import { RouteWhenAuthenticated } from 'common/components';

import LoadingPage from '../components/LoadingPage';
import { ReportForm } from '../components/reports/ReportForm';
import { Download } from '../components/reports/screens/Download';
import { Failed } from '../components/reports/screens/Failed';
import { Success } from '../components/reports/screens/Success';
import { Unsubscribed } from '../components/reports/screens/Unsubscribed';
import { useInsightSubRoutes } from '../hooks/useInsightsSubRoutes';
import { useIsReportsEnabled } from '../hooks/useIsReportsEnabled';
import { InsightEntity } from '../types';

type ReportsPageProps = {
  insightEntity: InsightEntity;
  dateInterval: Interval;
  isVATEnabled: boolean;
};

const ReportsPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ReportsPage = ({ insightEntity }: ReportsPageProps) => {
  const { path } = useRouteMatch();
  const {
    indexLink,
    reports: { newLink: newReportLink },
  } = useInsightSubRoutes();
  const history = useHistory();
  const { isLoading, isReportsEnabled } = useIsReportsEnabled(insightEntity.type);

  const handleBackToInsights = () => {
    history.push(indexLink(history.location));
  };
  const handleCreateReport = () => {
    history.push(newReportLink(history.location));
  };

  if (isLoading) {
    return <LoadingPage />;
  }

  if (insightEntity.type === 'venue' || !isReportsEnabled) {
    return <Redirect to={indexLink(history.location)} />;
  }

  return (
    <ReportsPageContainer>
      <Switch>
        <RouteWhenAuthenticated exact path={`${path}/new`}>
          <ReportForm venues={insightEntity.venues} />
        </RouteWhenAuthenticated>
        <RouteWhenAuthenticated exact path={`${path}/success`}>
          <Success onBack={handleBackToInsights} />
        </RouteWhenAuthenticated>
        <RouteWhenAuthenticated exact path={`${path}/failed`}>
          <Failed onBack={handleBackToInsights} onCreate={handleCreateReport} />
        </RouteWhenAuthenticated>
        <RouteWhenAuthenticated exact path={`${path}/unsubscribed`}>
          <Unsubscribed onBack={handleBackToInsights} />
        </RouteWhenAuthenticated>
        <RouteWhenAuthenticated exact path={`${path}/download`}>
          <Download onBack={handleBackToInsights} />
        </RouteWhenAuthenticated>
      </Switch>
    </ReportsPageContainer>
  );
};

export default ReportsPage;
